export const environment = {
  production: false,
  idioma: "es",
  token: 'CH1L3P454J35_4PP_M0B1L3_PRUE845',
  authToken: 'D07Vc2nNKYg0CmK',
  tokenFromUI: 'eR7vRetZTNE6rF0g',
  newDomainUrl:'chilepasajes.cl',
  newDomainName:'Chilepasajes.cl',
  urlApiChilepasajes: 'https://chilepasajes.azure-api.net/WebPruebas',
  urlApiManagement: 'https://api-management-chilepasajes-eu.azure-api.net/WebPruebas',
  urlApiGatwayCache:'https://prg5dz1za1.execute-api.us-east-1.amazonaws.com/dev-v1',
  urlSitio: 'https://api-chilepasajes-pruebas.azurewebsites.net',
  urlClickyPaga: 'https://api.clickypaga.cl/api/orders',
  urlCache: 'https://httpcachedeleteclp.azurewebsites.net',
  urlChilePasajes: 'https://chilepasajes.cl',
  urlTransantin: 'https://ventas.transantin.cl',
  urlCdn: 'https://cdn-chilepasajes.azureedge.net/cdn-clp',
  urlApiPanoramas: 'https://api-chilepasajes-brasil-us.azurewebsites.net',
  app: {
    ios: 'https://apps.apple.com/app/apple-store/id1521778107',
    android: 'https://play.google.com/store/apps/details?id=io.ionic.chile.pasajes'
  },
  redes: {
    facebook: 'https://www.facebook.com/Chilepasajes',
    twitter: 'https://x.com/ChilePasajescl',
    instagram: 'https://www.instagram.com/chilepasajesoficial/',
    youtube: 'https://www.youtube.com/@Chile-Pasajes'
  },
  webpay: 'https://webpay-prod.chilepasajes.cl',
  googleAnalyticsIdEnbus: 'G-LV4BWH9D6D',
  googleTagManagerIdChile: 'GTM-WF2CK73',
  googleMapsApiKey: 'AIzaSyBWQYaqUIeuRM8sptx8WKGtkJWJElSsUCw',
  googleClientId: '571050017993-d4bmia9qbenfjdsm8mts4urrkhso8320.apps.googleusercontent.com'
};